import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'

import ClientHeader from '../../components/ClientHeader/ClientHeader'
import DetailsSummarySection from '../../components/details/summary/DetailsSummarySection'
import TabsMui from '../../layout/TabsMui'
import { TASK_TYPES } from '../constants/constants'
import PosDetailsSurvey from '../details/PosDetailsSurvey'
import PosTaskInventoryReport from './report/PosTaskInventoryReport'
import PosTaskPlanimetryReport from './report/PosTaskPlanimetryReport'
import PosTaskPriceCaptureReport from './report/PosTaskPriceCaptureReport'
import {
  REPORT_CLIENT_HEADER_CONFIG,
  REPORT_TAB_VALUE,
  REPORT_TABS,
  PosTaskReportDownloadButton,
  buildPosTaskReportSummaryFields
} from './report/posTaskReportShared'

function getReportExtra(activity) {
  if (activity.task_type === TASK_TYPES.survey.key) {
    return {
      extraContent: (
        <PosDetailsSurvey
          data={activity.task_data?.surveys || []}
          responses={activity.details_survey || []}
          surveyItems={activity.survey_items || []}
          images={activity.planimetry_images || []}
          uid={activity.uid}
          reportMode
        />
      )
    }
  }

  if (activity.task_type === TASK_TYPES.inventory.key) {
    return {
      extraContent: <PosTaskInventoryReport activity={activity} />
    }
  }

  if (activity.task_type === TASK_TYPES.price_capture.key) {
    return {
      extraContent: <PosTaskPriceCaptureReport activity={activity} />
    }
  }

  if (activity.task_type === TASK_TYPES.planimetry.key) {
    return {
      extraContent: <PosTaskPlanimetryReport activity={activity} />
    }
  }

  return {}
}

export default function PosTaskActivityReportView({ activity }) {
  const [activeTab, setActiveTab] = useState(REPORT_TAB_VALUE)

  if (!activity) return null

  const summaryFields = buildPosTaskReportSummaryFields(activity)
  const { extraFields = [], extraContent = null } = getReportExtra(activity)

  return (
    <>
      <div className="main-show-header">
        <h2>Tarea en punto de venta: {activity.uid}</h2>
      </div>

      <div className="index-table">
        <div className="show-area">
          <div className="show-area-tabs-header pos-details-tabs-header">
            <TabsMui
              tabs={REPORT_TABS}
              activeTab={activeTab}
              onChange={setActiveTab}
              showDivider={false}
              marginBottom={0}
            />
          </div>

          {activeTab === REPORT_TAB_VALUE && (
            <div className="tab-content-area">
              <div className="container-fluid px-0">
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    flexWrap: 'wrap',
                    mt: 3,
                    mb: 3,
                    ml: '5px'
                  }}
                >
                  <Typography sx={{ fontSize: 18, m: 0, lineHeight: 1.3 }}>
                    Detalles de la tarea:
                  </Typography>

                  <PosTaskReportDownloadButton activity={activity} />
                </Box>

                <ClientHeader
                  data={activity}
                  config={REPORT_CLIENT_HEADER_CONFIG}
                  cardSx={{ p: 2, mb: 2 }}
                />

                <DetailsSummarySection
                  summaryFields={summaryFields}
                  extraFields={extraFields}
                  extraContent={extraContent}
                  summaryTitle="DETALLES DE LA TAREA"
                  extraTitle="DETALLES DE REPORTE"
                  summaryColumns={{ xs: '1fr', md: '1fr 1fr' }}
                  extraColumns={{ xs: '1fr', md: '1fr 1fr' }}
                  secondarySectionsType="title"
                  summaryOpenLabel="Abrir detalles de la tarea"
                  summaryCloseLabel="Cerrar detalles de la tarea"
                  extraOpenLabel="Abrir detalles del reporte"
                  extraCloseLabel="Cerrar detalles del reporte"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
